var React = require('react');

function Mailwhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon","d":"M26.72,20.875H0V4.844L13.363,12.9,26.72,4.892V20.875ZM13.36,9.941h0L2.672,3.4,0,1.763V0H26.72V1.82L24.048,3.445,13.361,9.94Z","fill":"currentColor"}));
}

Mailwhite.defaultProps = {"width":"26.721","height":"20.875","viewBox":"0 0 26.721 20.875"};

module.exports = Mailwhite;

Mailwhite.default = Mailwhite;
